import { render } from "./two-authentication-factor.vue?vue&type=template&id=6d454672"
import script from "./two-authentication-factor.vue?vue&type=script&lang=js"
export * from "./two-authentication-factor.vue?vue&type=script&lang=js"

import "./two-authentication-factor.vue?vue&type=style&index=0&id=6d454672&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__